import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/custom/Hero.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
